<template>
    <form>
        <b-modal :active.sync="isComponentModalActive"
                 has-modal-card full-screen >

            <div class="modal-card ">
                <section class="modal-card-body"  >
                    <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
                    <template>
                        <section>


                            <div class="container">
                                <b-field label="Name">
                                    <b-input v-model="datEditNews.title" style="width: 100%"></b-input>
                                </b-field>


                                <b-field label="Image" >

                                    <nav class="level">
                                        <div class="level-left">
                                            <div class="level-item">
                                                <div class="file is-boxed is-primary">
                                                    <label class="file-label">
                                                        <input
                                                                type="file"
                                                                ref="file"
                                                                @change="selectFileAndUp"
                                                                class="file-input"
                                                        >
                                                        <span class="file-cta">
                                                             <span class="file-icon">
                                                                 <i class="fas fa-upload"></i>
                                                             </span>
                                                             <span class="file-label">
                                                               Choose a file...
                                                             </span>
                                                         </span>
                                                        <span v-if="file" class="file-name">{{file.name}}</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="level-item" v-if="!urlTempUploaded">
                                                <figure class=" field image is-128x128" >
                                                    <img  :src="getImageUrl(datEditNews.images)" alt="Image"  >
                                                </figure>
                                            </div>
                                            <div class="level-item" v-if="urlTempUploaded" >
                                                <figure class=" field image is-128x128">
                                                    <img  :src="urlTempUploaded" alt="Image" >
                                                </figure>
                                            </div>

                                        </div>
                                        <div class="level-right">

                                        </div>
                                    </nav>

                                </b-field>




                                <b-field label="Name">
                                                <vue-editor v-model="datEditNews.descptoin_html"  :editor-toolbar="customToolbar"   id="editor1"   />
                                </b-field>


<!--                                {{ datEditNews.descptoin_html }}-->


                                <b-field label="">
                                    <b-button size="is-medium"
                                              type="is-success"
                                              icon-left="cloud-upload"
                                              @click="saveNews" >
                                        Save
                                    </b-button>
                                </b-field>


                            </div>






                        </section>
                    </template>


                </section>
                <footer class="modal-card-foot">
                    <b-button size="is-medium" type="is-danger"
                              icon-left="close" @click="closeModal">
                        Close
                    </b-button>
                </footer>
            </div>

        </b-modal>
    </form>
</template>

<script>
    /* eslint-disable no-console */
    import axios from "axios";
    import {getConfigAxios , getBaseURLforBackEnd ,getBaseURLLabNews }  from '@/utils.js'
    import htmlToText from "html-to-text";
    import { mapState } from "vuex";


    export default {
        name: "EditNews" ,
        computed:{

             ...mapState({
                access_token: state => state.master_data.access_token,
            }),


            // countText(){
            //     let text = this.datEditNews.descptoin_html.replace(/<\/?[^>]+(>|$)/g, '');
            //     let len = text.length;
            //     return len;
            // },
            getTextFromHTML:function () {
                return  htmlToText.fromString(this.datEditNews.descptoin_html, {
                    wordwrap: 80,
                    ignoreImage: true ,
                    ignoreHref: true
                });
            }
        },
        methods:{

            saveNews(){

                this.datEditNews.descptoin_txt = this.getTextFromHTML
                const  vm = this
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`  
                axios.post(`${getBaseURLforBackEnd()}/api/updatenews`,this.datEditNews,getConfigAxios())
                    .then((res)=>{
                        if(res.status === 200){
                           vm.$buefy.toast.open({
                               message: `${res.data.msg}`,
                               type: 'is-success'
                           })
                           vm.closeModalWithChange()
                        }
                    })

            },
            getImageUrl(img){
              return  `${getBaseURLLabNews()}/${img}`
            },
            closeModalWithChange(){
                this.$emit('closeModalWithChange')
                this.isComponentModalActive = false
            },
            closeModal(){
                this.isComponentModalActive = false
            },
            async selectFileAndUp(){
                const file = this.$refs.file.files[0]
                const allowedTypes = ["image/jpeg","image/png","image/gif","image/jpg"]
                const MAX_SIZE = 20000000
                const tooLarge = file.size > MAX_SIZE

                if(allowedTypes.includes(file.type) && !tooLarge){
                    this.file = file
                    this.message = ""
                    this.error = false
                    // console.log('ok')

                    const formData = new FormData()
                    const vm = this
                    formData.append('file',this.file)
                    formData.append('dat','{ "mode": 1}')
                    try{
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                        await axios.post(`${getBaseURLforBackEnd()}/api/uploadimagenews`,formData,getConfigAxios())
                            .then((res)=>{
                                vm.urlTempUploaded = res.data.temp_url
                                vm.fileNameUploaded = res.data.file_name
                            })
                        // this.file = ""
                        this.error = false
                    }catch (e) {
                        this.message = e.response.data.error
                        this.error = true
                        if (e.response && e.response.status === 401) {
                            vm.isFullScreenSearching = false
                            vm.$router.push('/login')
                        }
                    }


                }else{
                    this.message = tooLarge ? `Max size ${MAX_SIZE/1000} kb` : "Only images are allow (from Client)"
                    this.error = true
                }


            },
        },
        data(){
            return {
                isComponentModalActive : false,
                isFullScreenLoading : false,

                datEditNews : {},
                file: '',
                urlTempUploaded : '',
                customToolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    // ["image", "code-block"],
                    [ "code-block"],
                    [{ 'color': [] }, { 'background': [] }],
                ],
            }

        },
        watch: {
            urlTempUploaded: function (val) {
                if (val !== '') {
                    this.datEditNews.image_fresh = true
                    this.datEditNews.urlTempUploaded = this.urlTempUploaded
                    this.datEditNews.images = this.file.name
                }
            },



        }
    }
</script>

<style scoped>

</style>